export default __webpack_public_path__ + "static/media/inovacao.6e00ba23.png";